export const CLEAR_RECENT_SEARCHES_COMMAND_VALUE = 'clear_recent_searches'
export const SEARCH_MORE_CREATORS_COMMAND_VALUE = 'search_more_creators'
export const SHOW_MORE_RESULTS_COMMAND_VALUE = 'show_more_results'

export const getCreatorCommandValue = (creator) =>
    ['creator', creator.key, creator.displayName, creator.handle, creator.platformId].filter(Boolean).join(' ')
